import { render, staticRenderFns } from "./HeaderMenu2.vue?vue&type=template&id=8c773c82&"
import script from "./HeaderMenu2.vue?vue&type=script&lang=js&"
export * from "./HeaderMenu2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports